import { lazy, Suspense } from 'react';
import { AuthProvider } from '@/security/auth-provider';
import { AppProviders } from '@/app/providers';
import { useAuthStore } from '@/stores/auth.store';

const AUTH_MODE = import.meta.env.VITE_AUTH_MODE || 'dev';

export default function App() {
  if (AUTH_MODE === 'dev') {
    return (
      <AuthProvider
        user={{ username: 'multi@docautomation.io', userId: 'demo-multi-scope', role: 'admin' }}
        signOut={() => {}}
      >
        <AppProviders />
      </AuthProvider>
    );
  }

  if (AUTH_MODE === 'demo') {
    return <DemoApp />;
  }

  return <CognitoApp />;
}

function DemoApp() {
  const demoUser = useAuthStore((s) => s.demoUser);

  const user = demoUser
    ? {
        username: demoUser.email,
        userId: 'demo-user-001',
        role: demoUser.role,
        signInDetails: { loginId: demoUser.email },
      }
    : null;

  return (
    <AuthProvider
      user={user}
      signOut={() => useAuthStore.getState().clearDemoUser()}
    >
      <AppProviders />
    </AuthProvider>
  );
}

const CognitoAppLazy = lazy(
  () => import('@/features/authentication/components/cognito-login'),
);

function CognitoApp() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center text-text-secondary">
          Loading...
        </div>
      }
    >
      <CognitoAppLazy />
    </Suspense>
  );
}
